// @flow

import { Map, fromJS, isImmutable } from "immutable";

const resourceToImmutable = (resource: {} | Map<string, *>): Map<string, *> => {
  if (isImmutable(resource)) {
    return resource;
  }

  // @todo Re-add deprecated warning to verify all resources are now immutable
  // deprecated("You be using just immutables for resources now");

  // $FlowFixMe
  return fromJS(resource);
};

export default resourceToImmutable;



// WEBPACK FOOTER //
// ./src/utils/resourceToImmutable.js